import api from 'src/configs/api';
import { TProfile, TUpdateStatus, TUpdateUserPersonal } from 'src/types/profiles/profile.model';

const prefix = 'api/user';

export const postCreateUser = async (param: TProfile) => {
  try {
    const res = await api.post(`${prefix}`, param);
    return res.data;
  } catch (error: any) {
  
  
  return error
  }
};

export const putUpdateProfile = async (param: TProfile) => {
  try {
    const res = await api.put(`${prefix}`, param);
    return res.data;
  } catch (error: any) {
 
  return error
  }
};

export const putUpdateUserPersonal = async (param: TUpdateUserPersonal) => {
  try {
    const res = await api.put(`${prefix}/update-personal/${param.userId}`, param);
    return res.data;
  } catch (error: any) {
   
    return error
  }
};

export const getUserInfoByUserId = async (userId: number) => {
  try {
    const res = await api.get(`${prefix}/${userId}`);
    return res.data;
  } catch (error: any) {
   
   
    return error
  }
};

export const putUpdateUserProfile = async (param: TProfile) => {
  try {
    const res = await api.put(`${prefix}/profile/${param.userId}`, param);
    return res.data;
  } catch (error: any) {
  return error
}
}

export const putUpdateUserStatus = async (param: TUpdateStatus) => {
  try {
    const res = await api.put(`${prefix}/update-status/${param.userId}`, param);
    return res.data;
  } catch (error: any) {
   
    
    return error
  }
};
